import { Request } from "express";

import { IParamBinder } from "./IParamBinder";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IValueParser = (value: any) => unknown;

export class UrlParamBinder implements IParamBinder {
    private readonly name: string;
    private readonly valueParser: IValueParser;

    public constructor(name: string, valueParser: IValueParser) {
        this.name = name;
        this.valueParser = valueParser;
    }

    public extractValue(req: Request): unknown {
        return this.valueParser(req.params[this.name]);
    }
}
